import React, { useEffect, useState } from "react"
import ReactDom from "react-dom";
import { useSelector } from "react-redux";
import { DynamicMessageTypeEnum } from "../../../../models/DynamicMessageTypeEnum";
import { DeleteIcon, DownIcon, DuplicateIcon, UpIcon } from "../../../../UI/ActionsIcons";
import DynamicMessage from "../../../../UI/Popups/DynamicMessage/DynamicMessage";
import classes from './ReflectionToolBar.module.css';

const ReflectionToolBar = ({ currentIndex, listLength, question, deleteReflectionCallback, copyReflection, exchangeOrder, portalId }) => {
    const { texts } = useSelector(state => state.translate);
    const [messagePopup, setMessagesPopup] = useState(null)
    const [domReady, setDomReady] = useState(false)

    useEffect(() => {
        setDomReady(true)
    }, [])

    const deleteReflection = () => {
        setMessagesPopup(
            <DynamicMessage
                type={DynamicMessageTypeEnum.Warn}
                content={texts.warnBeforeDeleteReflectionQuestion}
                cancelFunc={() => setMessagesPopup(null)}
                confirmFunc={() => {
                    setMessagesPopup(null);
                    deleteReflectionCallback(question.id)
                }} />)
    }


    return <>
        {domReady && ReactDom.createPortal(
            (<div>
                <div className={classes.Actions}>
                    <DownIcon onClick={() => currentIndex + 1 !== listLength && question?.id && exchangeOrder(currentIndex + 1)} className={currentIndex + 1 === listLength && !question?.id && listLength > 0 ? classes.Disable : null} />
                    <UpIcon onClick={() => currentIndex - 1 >= 0 && question?.id && exchangeOrder(currentIndex - 1)} className={currentIndex - 1 < 0 && !question?.id && listLength > 0 ? classes.Disable : null} />
                    <DuplicateIcon onClick={() => copyReflection({ type: question.type, text: question.text }, 'COPY')} />
                    <DeleteIcon onClick={() => deleteReflection()} />
                </div>
                {messagePopup}
            </div>), document.getElementById(portalId)
        )}
    </>

}

export default ReflectionToolBar;